/**
 * Update Status message catalog for webhook simulation.
 * Derived from ServicePlus_API_Request_V.2.xlsx - Update Status.csv and docs/webhooks/*.json.
 */

export type Document = "Export" | "GCL" | "Cancel" | "Short";

export interface UpdateStatusEntry {
  id: string;
  document: Document;
  statusCode: string;
  messageType: string;
  description: string;
  payload: Record<string, unknown>;
}

// Template payloads (from docs/webhooks/*.json). Keys match entry id for lookup.
const payloads: Record<string, Record<string, unknown>> = {
  Export_TIFM_0200_WAITING_RESPONSE: {
    InterfaceId: "49fb9096-6646-4717-85a7-1309488ae6a5",
    MessageType: "TIFM",
    OMSCustomsId: "107044",
    ReferenceNumber: "0123456789",
    Status: "0200",
    Message: "WAITING RESPONSE",
  },
  Export_TIFM_0200_SIGN_SUCCEEDED: {
    InterfaceId: "49fb9096-6646-4717-85a7-1309488ae6a5",
    MessageType: "TIFM",
    OMSCustomsId: "107044",
    ReferenceNumber: "0123456789",
    Status: "0200",
    Message: "Sign Succeeded",
  },
  Export_XDCA_0209: {
    InterfaceId: "49fb9096-6646-4717-85a7-1309488ae6a5",
    MessageType: "XDCA",
    OMSCustomsId: "107044",
    ReferenceNumber: "0123456789",
    Status: "0209",
    ResponseMessage: [
      {
        DeclarationNumber: "TIFF1234567890",
        TotalTax: "99.99",
        TotalDeposit: "0.00",
        FOBValueBaht: "823,377.39",
        RateofExchange: "31.08",
        ReleasePort: "1234",
        Message: "Accept Message",
      },
    ],
  },
  Export_GCLD_0301: {
    InterfaceId: "49fb9096-6646-4717-85a7-1309488ae6a5",
    MessageType: "GCLD",
    OMSCustomsId: "1234567890",
    ReferenceNumber: "TIFF000401146",
    Status: "0301",
    ResponseMessage: [
      {
        DeclarationNo: "",
        ContrainerNo: "OOLU1125925",
        LocalPort: "1234",
        Message: "Goods Transition Control Already Checked ให้มาตรวจของที่ท่าที่ส่งออก",
        AuditDateTime: "2020-11-20T11:44:00",
      },
    ],
  },
  Export_GCLD_0309: {
    InterfaceId: "49fb9096-6646-4717-85a7-1309488ae6a5",
    MessageType: "GCLD",
    OMSCustomsId: "1234567890",
    ReferenceNumber: "TIFF000401146",
    Status: "0309",
    ResponseMessage: [
      {
        DeclarationNo: "",
        ContrainerNo: "OOLU1125925",
        LocalPort: "1234",
        Message: "Goods Transition Control Already Checked",
        AuditDateTime: "2020-11-20T11:44:00",
      },
    ],
  },
  Export_GCLD_0409: {
    InterfaceId: "49fb9096-6646-4717-85a7-1309488ae6a5",
    MessageType: "GCLD",
    OMSCustomsId: "1234567890",
    ReferenceNumber: "TIFF000401146",
    Status: "0409",
    ResponseMessage: [
      {
        DeclarationNo: "",
        ContrainerNo: "OOLU1125925",
        LocalPort: "1234",
        Message: "GOODS LOADED",
        AuditDateTime: "2020-11-20T11:44:00",
      },
    ],
  },
  Export_XDCR_0000: {
    InterfaceId: "49fb9096-6646-4717-85a7-1309488ae6a5",
    MessageType: "XDCR",
    OMSCustomsId: "107044",
    ReferenceNumber: "TIFF0123456789",
    Status: "0000",
    ResponseMessage: [{ ItemNumber: "001", ErrorCode: "ERR001", Message: "Declaration Rejected" }],
  },
  Export_XDCR_9901: {
    InterfaceId: "49fb9096-6646-4717-85a7-1309488ae6a5",
    MessageType: "XDCR",
    OMSCustomsId: "107044",
    ReferenceNumber: "TIFF0123456789",
    Status: "9901",
    ResponseMessage: [
      { ItemNumber: "001", ErrorCode: "ERR001", Message: "Error Message" },
      { ItemNumber: "002", ErrorCode: "ERR001", Message: "Error Message" },
    ],
  },
  Export_TIFM_9700: {
    InterfaceId: "49fb9096-6646-4717-85a7-1309488ae6a5",
    MessageType: "TIFM",
    OMSCustomsId: "107044",
    ReferenceNumber: "0123456789",
    Status: "9700",
    Message: "Sign Failed",
  },
  Export_TIFM_9701: {
    InterfaceId: "49fb9096-6646-4717-85a7-1309488ae6a5",
    MessageType: "TIFM",
    OMSCustomsId: "107044",
    ReferenceNumber: "0123456789",
    Status: "9701",
    Message: "Send to RTC Failed",
  },
  Export_TIFM_9704: {
    InterfaceId: "49fb9096-6646-4717-85a7-1309488ae6a5",
    MessageType: "TIFM",
    OMSCustomsId: "107044",
    ReferenceNumber: "0123456789",
    Status: "9704",
    Message: "Error Schema from RTC/NSW",
  },
  GCL_TIFM_0000: {
    InterfaceId: "49fb9096-6646-4717-85a7-1309488ae6a5",
    MessageType: "TIFM",
    OMSCustomsId: "1234567890",
    ReferenceNumber: "TIFF0123456789",
    Status: "0000",
    Message: "VALIDATE FAILED",
  },
  GCL_TIFM_0300: {
    InterfaceId: "49fb9096-6646-4717-85a7-1309488ae6a5",
    MessageType: "TIFM",
    OMSCustomsId: "1234567890",
    ReferenceNumber: "TIFF0123456789",
    Status: "0300",
    Message: "SENT TO CUSTOMS - WAITING RESPONSE",
  },
  GCL_GCLA_0209: {
    InterfaceId: "49fb9096-6646-4717-85a7-1309488ae6a5",
    MessageType: "GCLA",
    OMSCustomsId: "1234567890",
    ReferenceNumber: "TIFF0123456789",
    Status: "0209",
    ResponseMessage: [
      {
        GoodsTransitionNumber: "1234567890",
        ContainerNumber: "1234567890",
        LoadPort: "1234",
        Message: "Goods Control Accepted",
      },
    ],
  },
  GCL_GCLA_0300: {
    InterfaceId: "49fb9096-6646-4717-85a7-1309488ae6a5",
    MessageType: "GCLA",
    OMSCustomsId: "1234567890",
    ReferenceNumber: "TIFF0123456789",
    Status: "0300",
    ResponseMessage: [
      {
        GoodsTransitionNumber: "1234567890",
        ContainerNumber: "1234567890",
        LoadPort: "1234",
        Message: "Accept Message",
      },
    ],
  },
  GCL_GCLA_LCB_0209: {
    InterfaceId: "49fb9096-6646-4717-85a7-1309488ae6a5",
    MessageType: "GCLA_LCB",
    OMSCustomsId: "1234567890",
    ReferenceNumber: "TIFF0123456789",
    Status: "0209",
    ResponseMessage: [
      {
        GoodsTransitionNumber: "1234567890",
        ContainerNumber: "1234567890",
        LoadPort: "1234",
        Message: "Goods Control Accepted - Laem Chabang",
      },
    ],
  },
  GCL_GCLA_BKK_0209: {
    InterfaceId: "49fb9096-6646-4717-85a7-1309488ae6a5",
    MessageType: "GCLA_BKK",
    OMSCustomsId: "1234567890",
    ReferenceNumber: "TIFF0123456789",
    Status: "0209",
    ResponseMessage: [
      {
        GoodsTransitionNumber: "1234567890",
        ContainerNumber: "1234567890",
        LoadPort: "1234",
        Message: "Goods Control Accepted - Bangkok",
      },
    ],
  },
  GCL_GCLA_B2B_0209: {
    InterfaceId: "49fb9096-6646-4717-85a7-1309488ae6a5",
    MessageType: "GCLA_B2B",
    OMSCustomsId: "1234567890",
    ReferenceNumber: "TIFF0123456789",
    Status: "0209",
    ResponseMessage: [
      {
        GoodsTransitionNumber: "1234567890",
        ContainerNumber: "1234567890",
        LoadPort: "1234",
        Message: "Goods Control Accepted - B2B",
      },
    ],
  },
  GCL_GCLD_0301: {
    InterfaceId: "49fb9096-6646-4717-85a7-1309488ae6a5",
    MessageType: "GCLD",
    OMSCustomsId: "1234567890",
    ReferenceNumber: "TIFF000401146",
    Status: "0301",
    ResponseMessage: [
      {
        DeclarationNo: "",
        ContrainerNo: "OOLU1125925",
        LocalPort: "1234",
        Message: "Goods Transition Control Already Checked ให้มาตรวจของที่ท่าที่ส่งออก",
        AuditDateTime: "2020-11-20T11:44:00",
      },
    ],
  },
  GCL_GCLD_0309: {
    InterfaceId: "49fb9096-6646-4717-85a7-1309488ae6a5",
    MessageType: "GCLD",
    OMSCustomsId: "1234567890",
    ReferenceNumber: "TIFF000401146",
    Status: "0309",
    ResponseMessage: [
      {
        DeclarationNo: "",
        ContrainerNo: "OOLU1125925",
        LocalPort: "1234",
        Message: "Goods Transition Control Already Checked",
        AuditDateTime: "2020-11-20T11:44:00",
      },
    ],
  },
  GCL_GCLR_0000: {
    InterfaceId: "49fb9096-6646-4717-85a7-1309488ae6a5",
    MessageType: "GCLR",
    OMSCustomsId: "1234567890",
    ReferenceNumber: "TIFF0123456789",
    Status: "0000",
    ResponseMessage: [{ ItemNumber: "001", ErrorCode: "ERR001", Message: "Goods Control Reject" }],
  },
  GCL_GCLR_LCB_0000: {
    InterfaceId: "49fb9096-6646-4717-85a7-1309488ae6a5",
    MessageType: "GCLR_LCB",
    OMSCustomsId: "1234567890",
    ReferenceNumber: "TIFF0123456789",
    Status: "0000",
    ResponseMessage: [
      { ItemNumber: "001", ErrorCode: "ERR001", Message: "Goods Control Reject - Laem Chabang" },
    ],
  },
  GCL_GCLR_BKK_0000: {
    InterfaceId: "49fb9096-6646-4717-85a7-1309488ae6a5",
    MessageType: "GCLR_BKK",
    OMSCustomsId: "1234567890",
    ReferenceNumber: "TIFF0123456789",
    Status: "0000",
    ResponseMessage: [
      { ItemNumber: "001", ErrorCode: "ERR001", Message: "Goods Control Reject - Bangkok" },
    ],
  },
  GCL_GCLR_9901: {
    InterfaceId: "49fb9096-6646-4717-85a7-1309488ae6a5",
    MessageType: "GCLR",
    OMSCustomsId: "1234567890",
    ReferenceNumber: "TIFF0123456789",
    Status: "9901",
    ResponseMessage: [
      { ItemNumber: "001", ErrorCode: "ERR001", Message: "Error Message" },
      { ItemNumber: "002", ErrorCode: "ERR001", Message: "Error Message" },
    ],
  },
  GCL_GCLD_9904: {
    InterfaceId: "49fb9096-6646-4717-85a7-1309488ae6a5",
    MessageType: "GCLD",
    OMSCustomsId: null,
    ReferenceNumber: "TIFF000401146",
    Status: "9904",
    ResponseMessage: [
      {
        Timestamp: "2012-04-11T21:31:33",
        DeclarationNo: "",
        ContrainerNo: "OOLU1125925",
        LocalPort: "1234",
        Message: "GOODS TRANSITION CONTROL ALREADY CANCEL MATCHING",
        AuditDateTime: "2020-11-20T11:44:00",
      },
    ],
  },
  Cancel_XCDA_0300: {
    InterfaceId: "49fb9096-6646-4717-85a7-1309488ae6a5",
    MessageType: "XCDA",
    CustomsShipmentId: "0123456789",
    ReferenceNumber: "TIFF123456789",
    Status: "0300",
    ResponseMessage: [{ DocumentNumber: "1234567890", Message: "Accept Message" }],
  },
  Cancel_XCDA_9902: {
    InterfaceId: "49fb9096-6646-4717-85a7-1309488ae6a5",
    MessageType: "XCDA",
    OMSCustomsId: "107044",
    ReferenceNumber: "TIFF123456789",
    Status: "9902",
    ResponseMessage: [{ DocumentNumber: "1234567890", Message: "DECLARATION CANCELED" }],
  },
  Cancel_XCDA_9903: {
    InterfaceId: "49fb9096-6646-4717-85a7-1309488ae6a5",
    MessageType: "XCDA",
    OMSCustomsId: "107044",
    ReferenceNumber: "TIFF123456789",
    Status: "9903",
    ResponseMessage: [{ DocumentNumber: "1234567890", Message: "GOODS CONTROL CANCELED" }],
  },
  Cancel_XDCA_LCB_9903: {
    InterfaceId: "49fb9096-6646-4717-85a7-1309488ae6a5",
    MessageType: "XDCA_LCB",
    OMSCustomsId: "107044",
    ReferenceNumber: "TIFF123456789",
    Status: "9903",
    ResponseMessage: [
      { DocumentNumber: "1234567890", Message: "GOODS CONTROL CANCELED - Laem Chabang" },
    ],
  },
  Cancel_XDCA_BKK_9903: {
    InterfaceId: "49fb9096-6646-4717-85a7-1309488ae6a5",
    MessageType: "XDCA_BKK",
    OMSCustomsId: "107044",
    ReferenceNumber: "TIFF123456789",
    Status: "9903",
    ResponseMessage: [
      { DocumentNumber: "1234567890", Message: "GOODS CONTROL CANCELED - Bangkok" },
    ],
  },
  Cancel_GCLD_9904: {
    InterfaceId: "49fb9096-6646-4717-85a7-1309488ae6a5",
    MessageType: "GCLD",
    OMSCustomsId: null,
    ReferenceNumber: "TIFF000401146",
    Status: "9904",
    ResponseMessage: [
      {
        Timestamp: "2012-04-11T21:31:33",
        DeclarationNo: "",
        ContrainerNo: "OOLU1125925",
        LocalPort: "1234",
        Message: "GOODS TRANSITION CONTROL ALREADY CANCEL MATCHING",
        AuditDateTime: "2020-11-20T11:44:00",
      },
    ],
  },
  Cancel_XCDR_0000: {
    InterfaceId: "49fb9096-6646-4717-85a7-1309488ae6a5",
    MessageType: "XCDR",
    OMSCustomsId: "107044",
    ReferenceNumber: "TIFF123456789",
    Status: "0000",
    ResponseMessage: [
      { DocumentNumber: "1234567890", ErrorCode: "ERR001", Message: "Cancel Rejected" },
    ],
  },
  Cancel_XCDR_LCB_0000: {
    InterfaceId: "49fb9096-6646-4717-85a7-1309488ae6a5",
    MessageType: "XCDR_LCB",
    OMSCustomsId: "107044",
    ReferenceNumber: "TIFF123456789",
    Status: "0000",
    ResponseMessage: [
      {
        DocumentNumber: "1234567890",
        ErrorCode: "ERR001",
        Message: "Cancel Rejected - Laem Chabang",
      },
    ],
  },
  Cancel_XCDR_BKK_0000: {
    InterfaceId: "49fb9096-6646-4717-85a7-1309488ae6a5",
    MessageType: "XCDR_BKK",
    OMSCustomsId: "107044",
    ReferenceNumber: "TIFF123456789",
    Status: "0000",
    ResponseMessage: [
      {
        DocumentNumber: "1234567890",
        ErrorCode: "ERR001",
        Message: "Cancel Rejected - Bangkok",
      },
    ],
  },
  Cancel_XCDR_9901: {
    InterfaceId: "49fb9096-6646-4717-85a7-1309488ae6a5",
    MessageType: "XCDR",
    OMSCustomsId: "107044",
    ReferenceNumber: "TIFF123456789",
    Status: "9901",
    ResponseMessage: [
      { DocumentNumber: "1234567890", ErrorCode: "ERR001", Message: "Reject Message" },
      { DocumentNumber: "1234567890", ErrorCode: "ERR001", Message: "Reject Message" },
    ],
  },
  Short_TIFM_0000: {
    InterfaceId: "49fb9096-6646-4717-85a7-1309488ae6a5",
    MessageType: "TIFM",
    OMSCustomsId: null,
    ReferenceNumber: "TIFF800001468",
    Status: "0000",
    Message: "VALIDATE FAILED",
  },
  Short_TIFM_0400: {
    InterfaceId: "49fb9096-6646-4717-85a7-1309488ae6a5",
    MessageType: "TIFM",
    OMSCustomsId: null,
    ReferenceNumber: "TIFF800001468",
    Status: "0400",
    Message: "SENT TO CUSTOMS - WAITING RESPONSE",
  },
  Short_SDCA_9809: {
    InterfaceId: "49fb9096-6646-4717-85a7-1309488ae6a5",
    MessageType: "SDCA",
    OMSCustomsId: null,
    ReferenceNumber: "TIFF800001468",
    Status: "9809",
    ResponseMessage: [
      {
        ReferenceNumber: "TIFF1631102948",
        DeclarationNumber: "A0061631102948",
        DeclarationLineNumber: "0001",
        FOBValueForeign: "500",
        FOBValueBaht: "500",
        NetWeight: "100",
        GrossWeight: "100",
        Quantity: "10",
        PackageAmount: "10",
        Message: "SHORT DECLARATION ACCEPTED",
      },
      {
        ReferenceNumber: "TIFF1631102948",
        DeclarationNumber: "A0061631102948",
        DeclarationLineNumber: "0002",
        FOBValueForeign: "500",
        FOBValueBaht: "500",
        NetWeight: "100",
        GrossWeight: "100",
        Quantity: "10",
        PackageAmount: "10",
        Message: "SHORT DECLARATION ACCEPTED",
      },
      { DeclarationNumber: "A0041631102308", Message: "SHORT DECLARATION ACCEPTED" },
    ],
  },
  Short_SDCR_0000: {
    InterfaceId: "49fb9096-6646-4717-85a7-1309488ae6a5",
    MessageType: "SDCR",
    OMSCustomsId: null,
    ReferenceNumber: "TIFF800001468",
    Status: "0000",
    ResponseMessage: [
      {
        ReferenceNumber: "TIFF1631102948",
        DeclarationNumber: "A0061631102948",
        DeclarationLineNumber: "0",
        ErrorCode: "SHEX-00015",
        Message: "Error Message",
      },
      {
        ReferenceNumber: "TIFF1631102948",
        DeclarationNumber: "A0061631102948",
        DeclarationLineNumber: "1",
        ErrorCode: "SHEX-00015",
        Message: "Error Message",
      },
    ],
  },
};

const catalogEntries: Omit<UpdateStatusEntry, "payload">[] = [
  { id: "Export_TIFM_0200_WAITING_RESPONSE", document: "Export", statusCode: "0200", messageType: "TIFM", description: "WAITING RESPONSE" },
  { id: "Export_TIFM_0200_SIGN_SUCCEEDED", document: "Export", statusCode: "0200", messageType: "TIFM", description: "Sign Succeeded" },
  { id: "Export_XDCA_0209", document: "Export", statusCode: "0209", messageType: "XDCA", description: "DECLARATION ACCEPTED" },
  { id: "Export_GCLD_0301", document: "Export", statusCode: "0301", messageType: "GCLD", description: "GOODS CHECKED (Red)" },
  { id: "Export_GCLD_0309", document: "Export", statusCode: "0309", messageType: "GCLD", description: "GOODS CHECKED (Green)" },
  { id: "Export_GCLD_0409", document: "Export", statusCode: "0409", messageType: "GCLD", description: "GOODS LOADED" },
  { id: "Export_XDCR_0000", document: "Export", statusCode: "0000", messageType: "XDCR", description: "DECLARATION REJECTED" },
  { id: "Export_XDCR_9901", document: "Export", statusCode: "9901", messageType: "XDCR", description: "DECLARATION REJECTED" },
  { id: "Export_TIFM_9700", document: "Export", statusCode: "9700", messageType: "TIFM", description: "Sign Failed" },
  { id: "Export_TIFM_9701", document: "Export", statusCode: "9701", messageType: "TIFM", description: "Send to RTC Failed" },
  { id: "Export_TIFM_9704", document: "Export", statusCode: "9704", messageType: "TIFM", description: "Error Schema from RTC/NSW" },
  { id: "GCL_TIFM_0000", document: "GCL", statusCode: "0000", messageType: "TIFM", description: "VALIDATE FAILED" },
  { id: "GCL_TIFM_0300", document: "GCL", statusCode: "0300", messageType: "TIFM", description: "SENT TO CUSTOMS - WAITING RESPONSE" },
  { id: "GCL_GCLA_0209", document: "GCL", statusCode: "0209", messageType: "GCLA", description: "GOODS CONTROL ACCEPTED" },
  { id: "GCL_GCLA_0300", document: "GCL", statusCode: "0300", messageType: "GCLA", description: "GOODS CONTROL ACCEPTED (0300)" },
  { id: "GCL_GCLA_LCB_0209", document: "GCL", statusCode: "0209", messageType: "GCLA_LCB", description: "GOODS CONTROL ACCEPTED (LCB)" },
  { id: "GCL_GCLA_BKK_0209", document: "GCL", statusCode: "0209", messageType: "GCLA_BKK", description: "GOODS CONTROL ACCEPTED (BKK)" },
  { id: "GCL_GCLA_B2B_0209", document: "GCL", statusCode: "0209", messageType: "GCLA_B2B", description: "GOODS CONTROL ACCEPTED (B2B)" },
  { id: "GCL_GCLD_0301", document: "GCL", statusCode: "0301", messageType: "GCLD", description: "GOODS CHECKED (Red)" },
  { id: "GCL_GCLD_0309", document: "GCL", statusCode: "0309", messageType: "GCLD", description: "GOODS CHECKED (Green)" },
  { id: "GCL_GCLR_0000", document: "GCL", statusCode: "0000", messageType: "GCLR", description: "GOODS CONTROL REJECT" },
  { id: "GCL_GCLR_LCB_0000", document: "GCL", statusCode: "0000", messageType: "GCLR_LCB", description: "GOODS CONTROL REJECT (LCB)" },
  { id: "GCL_GCLR_BKK_0000", document: "GCL", statusCode: "0000", messageType: "GCLR_BKK", description: "GOODS CONTROL REJECT (BKK)" },
  { id: "GCL_GCLR_9901", document: "GCL", statusCode: "9901", messageType: "GCLR", description: "GOODS CONTROL REJECT" },
  { id: "GCL_GCLD_9904", document: "GCL", statusCode: "9904", messageType: "GCLD", description: "CANCEL MATCHING" },
  { id: "Cancel_XCDA_0300", document: "Cancel", statusCode: "0300", messageType: "XCDA", description: "CANCEL ACCEPTED" },
  { id: "Cancel_XCDA_9902", document: "Cancel", statusCode: "9902", messageType: "XCDA", description: "DECLARATION CANCELED" },
  { id: "Cancel_XCDA_9903", document: "Cancel", statusCode: "9903", messageType: "XCDA", description: "GOODS CONTROL CANCELED" },
  { id: "Cancel_XDCA_LCB_9903", document: "Cancel", statusCode: "9903", messageType: "XDCA_LCB", description: "GOODS CONTROL CANCELED (LCB)" },
  { id: "Cancel_XDCA_BKK_9903", document: "Cancel", statusCode: "9903", messageType: "XDCA_BKK", description: "GOODS CONTROL CANCELED (BKK)" },
  { id: "Cancel_GCLD_9904", document: "Cancel", statusCode: "9904", messageType: "GCLD", description: "CANCEL MATCHING" },
  { id: "Cancel_XCDR_0000", document: "Cancel", statusCode: "0000", messageType: "XCDR", description: "CANCEL REJECTED" },
  { id: "Cancel_XCDR_LCB_0000", document: "Cancel", statusCode: "0000", messageType: "XCDR_LCB", description: "CANCEL REJECTED (LCB)" },
  { id: "Cancel_XCDR_BKK_0000", document: "Cancel", statusCode: "0000", messageType: "XCDR_BKK", description: "CANCEL REJECTED (BKK)" },
  { id: "Cancel_XCDR_9901", document: "Cancel", statusCode: "9901", messageType: "XCDR", description: "CANCEL REJECTED" },
  { id: "Short_TIFM_0000", document: "Short", statusCode: "0000", messageType: "TIFM", description: "VALIDATE FAILED" },
  { id: "Short_TIFM_0400", document: "Short", statusCode: "0400", messageType: "TIFM", description: "SENT TO CUSTOMS - WAITING RESPONSE" },
  { id: "Short_SDCA_9809", document: "Short", statusCode: "9809", messageType: "SDCA", description: "SHORT DECLARATION ACCEPTED" },
  { id: "Short_SDCR_0000", document: "Short", statusCode: "0000", messageType: "SDCR", description: "SHORT DECLARATION REJECTED" },
];

export const UPDATE_STATUS_CATALOG: UpdateStatusEntry[] = catalogEntries.map((entry) => ({
  ...entry,
  payload: payloads[entry.id] ?? {},
}));

export const DOCUMENTS: Document[] = ["Export", "GCL", "Cancel", "Short"];

export function getEntriesByDocument(document: Document): UpdateStatusEntry[] {
  return UPDATE_STATUS_CATALOG.filter((e) => e.document === document);
}

export function getEntryById(id: string): UpdateStatusEntry | undefined {
  return UPDATE_STATUS_CATALOG.find((e) => e.id === id);
}
